import { AbstractControl, ValidatorFn } from "@angular/forms";
import { WebCallTopicService } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic.service";

/**
 * this is currently used with control.value which is the target display name
 * we see if when we do the conversion to a potential topic name it is valid, which assumes there
 * are no existing topic clashes - we handle those when we try topic add
 */
export function targetDisplayValid(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let validName = false;
    validName = checkValidity(control.value || "");
    // eslint-disable-next-line no-null/no-null
    return validName ? null : { targetDisplayValid: true };
  };
}

function checkValidity(targetDisplay: string): boolean {
  const target = targetDisplay
    .toLowerCase()
    .split(/[ `~!@#$%^&*()_+=,./<>?;':"|\\]/)
    .join("-");
  const regex = new RegExp("(^[a-z])([a-z0-9-]*)([a-z0-9]$)"); // does it start with a letter, followed by a series of letters and dashes,
  // end with a letter or number
  // eslint-disable-next-line no-null/no-null
  return target.match(regex) !== null;
}

/**
 * checks to make sure that the display name is unique,
 * optionally give a target to exclude so we don't invalidate same as itself (for edit case)
 */
export function targetDisplayUnique(
  webCallTopicService: WebCallTopicService,
  currentTarget?: string
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    let isUnique = false;
    isUnique = uniqueDisplay(control.value || "", webCallTopicService, currentTarget);
    // eslint-disable-next-line no-null/no-null
    return isUnique ? null : { targetDisplayNotUnique: true };
  };
}

function uniqueDisplay(
  targetDisplay: string,
  webCallTopicService: WebCallTopicService,
  currentTarget?: string
): boolean {
  const found = webCallTopicService.findInConfiguration("targetDisplay", targetDisplay);
  if (found && found.configuration && found.configuration.target === currentTarget) {
    return true; // found targetDisplay but it's on the topic we're checking against
  }
  return found ? false : true;
}
